export default __webpack_public_path__ + "static/media/nigerian-idol.abfe9a05.png";